<template>

    <section class="container">
        <div class="page-header mt-4">
            <div class="overly"></div>

            <div class="row justify-content-center align-items-center">
                <div class="col-lg-12">
                    <div class="content">
                        <h1 class="mb-3 text-white">Shop</h1>
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb bg-transparent justify-content-center">
                                <li class="breadcrumb-item"><a type="button" @click="RedirectToHomePage()">Home</a></li>
                                <li class="breadcrumb-item active" aria-current="page"><!--<a type="button" @click="RedirectToCurrentPage()">Shop</a>-->Shop</li>
                                <li v-if="CntCategoryName !=''" class="breadcrumb-item active" aria-current="page">{{CntCategoryName}}</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>

        </div>
    </section>


    <section class="container pd-80">

        <div class="row pt-4 mx-n2">
            <div class="col-lg-3 col-md-4">
                <div class="leftBarFilters">
                    <h3 class="widget-title h4 mb-2">Categories</h3>
                    <ul class="nav nav-category" id="categoryCollapseMenu">
                        <li class="nav-item w-100" v-for="(productitem,index) in ProductCatgoryList">
                            <!--<a type="button" :id='productitem.id' class="nav-link collapsed" data-bs-toggle="collapse" data-bs-target="#categoryFlushOne" aria-expanded="false" aria-controls="categoryFlushOne" @click="productcategoryid(productitem.id,0)">

                                {{ capitalized(productitem.categoryName)}}

                                <i class="feather-icon icon-chevron-right"></i>
                            </a>-->
                            <router-link :class="GetActiveCategoryCss(productitem.id)" class="nav-link collapsed" data-bs-toggle="collapse" data-bs-target="#categoryFlushOne" aria-expanded="false" aria-controls="categoryFlushOne"
                                         :to="`/Products/${productitem.id}`"
                                         @click="Clickproductcategory(productitem.id,0,productitem.categoryName)">
                                {{ capitalized(productitem.categoryName)}}
                            </router-link>
                        </li>
                    </ul>
                    <div id="mobile_categroy_dropdown" class="d-flex  align-items-center mb-3 ">
                        <select id="sorter" data-role="sorter" class="form-select">
                            <option v-if="ProductcategoryId == null || ProductcategoryId ==''" disabled value="null" selected>Products Category</option>
                            <option v-else selected>{{SelectcategoryName}}</option>
                            <option v-for="(productitem,index) in ProductCatgoryList" @click="GetSelectedCategoryProductsLists(productitem.id)">
                                <a href="#" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne" @click="GetSelectedCategoryProductsLists(productitem.id)">
                                    {{productitem.categoryName}}<i class="fa-solid fa-angle-right"></i>
                                </a>
                            </option>
                        </select>
                    </div>

                    <h3 class="widget-title h4 mb-2 hidemob">Featured Products</h3>

                    <div class="featureProd" v-for="(featureditem,index) in featuredproductdetails">
                        <div class="featureProdList">
                            <div class="featureProd-Img" v-if="featureditem.imageUrl != null">
                                <!--<div class="discount-badge">
                                    {{featureditem.discount}}%
                                </div>-->
                                <a type="button" @click="ProductDetailpage(featureditem.id)" v-if="$filters.IsNull(featureditem.imageUrl,true,null)!=null">
                                    <img class="img-fluid" :src="featureditem.imageUrl" alt="product">
                                </a>
                                <a type="button" @click="ProductDetailpage(featureditem.id)" v-else>
                                    <img class="img-fluid" src="../../assets/images/defaultNoImage.png" alt="product">
                                </a>
                            </div>
                            <div class="featureProd-desc">
                                <div class="star-rating">

                                </div>
                                <h3 type="button" @click="ProductDetailpage(featureditem.id)">{{ featureditem.productName}}</h3>



                                <div class="product-price" v-if="featureditem.price.toFixed(2) == featureditem.salePrice.toFixed(2)">
                                    ${{featureditem.salePrice.toFixed(2)}}
                                </div>

                                <div class="product-price" v-else>
                                    <del>${{featureditem.price.toFixed(2)}}</del>
                                    ${{featureditem.salePrice.toFixed(2)}}<span class="discount-text-orange d-block">({{featureditem.discount}}% Off)</span>
                                </div>


                            </div>
                        </div>
                    </div>


                </div>
            </div>
            <!-- Product-->
            <div class="col-lg-9 col-md-8">
                <div class="row mob-mg">
                    <div class=" d-flex justify-content-between align-items-center mb-4 p-0">
                        <div class="mb-lg-0">
                            <!-- <label class="sorthidedesk">Sort by:</label>
                            <select id="sorter" data-role="sorter" class="sorter-options form-control" v-model="productshort" @change="GetsortByProduct(productshort)">
                                <option disabled value="null">Please select an option</option>
                                <option v-for=" drpdata in DropdoenDataSortBy" :value="drpdata.Value"> {{drpdata.Text}}</option>

                            </select>-->
                            <Dropdown v-model="productshort"
                                      :options="DropdoenDataSortBy"
                                      optionValue="Text"
                                      optionLabel="Text"
                                      placeholder="Sort By"
                                      @change="GetsortByProduct(productshort)" />
                        </div>
                        <div class="d-md-flex justify-content-between align-items-center listing-switch-view">
                            <div class="d-flex align-items-center justify-content-between filterrw">
                                <div>
                                    <a href="#" v-on:click="layout = 'list'" class="switch-btn btn-list" v-bind:class="{ 'active': layout == 'list'}"><i class="fa-solid fa-list"></i></a>
                                    <a href="#" v-on:click="layout = 'grid'" :class="layout === 'list' ? 'switch-btn btn-grid' : 'switch-btn btn-grid active'" v-bind:class="{ 'active': layout == 'grid'}"><i class="fa-solid fa-grip"></i></a>
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-sm-4 col-md-4 col-lg-5 mb-0 mt-2 mt-md-0 flex-1 p-sm-0">
                            <div class="input-group search-filter">
                                <input class="form-control mr-2" type="text" v-model='searchTxt' placeholder="Search Product" @keyup.enter='search()'>
                                <button type="submit" class="btn btn-primary mr-2" @click="search()" title="Search">
                                    Search
                                </button>

                                <button type="submit" class="btn ml-2  btn-danger" @click="reset()" title="Reset"><i class="fas fa-redo-alt"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div :class="layout === 'list' ? 'row products list' : 'row products grid'">

                    <div class="card product-card bg-grey" v-for="(productitem,index) in ProductList" v-if="ProductList!= null && ProductList != ''">
                        <!--<div class="discount-badge">
                            {{productitem.discount}}%
                        </div>-->
                        <a class="card-img-top d-block overflow-hidden" type="button" @click="ProductDetailpage(productitem.productID)">
                            <img :src="productitem.imageUrl" alt="product">
                        </a>
                        <div class="card-body py-2">
                            <h3 class="product-title fs-sm">
                                <a type="button" @click="ProductDetailpage(productitem.productID)">
                                    {{productitem.productName}}
                                </a>
                            </h3>
                            <!--<div class="star-rating">
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                            </div>-->
                            <div class="product-price" v-if="productitem.price.toFixed(2) == productitem.salePrice.toFixed(2)">
                                ${{productitem.salePrice.toFixed(2)}}
                            </div>

                            <div class="product-price" v-else>
                                <del class="d-block">${{productitem.price.toFixed(2)}}</del>
                                ${{productitem.salePrice.toFixed(2)}}
                                <span class="discount-text-orange d-block">({{productitem.discount}}% Off)</span>
                            </div>

                        </div>
                        <div class="card-body card-body-hidden">
                            <a href="javascript:void(0)" class="btn btn-primary btn-sm d-block w-100 mb-2" v-if="productitem.availableStock > 0" type="button" @click="Path(productitem.productID,productitem.isShip,productitem.localDelCharges)">
                                Add to Cart
                            </a>

                            <button v-else class="btn btn-primary btn-sm d-block w-100 mb-2" disabled>
                                <i class="ci-cart fs-sm me-1"></i>Out Of Stock
                            </button>

                            <div class="text-center" @click="ProductDetailpage(productitem.productID)">
                                <a class="nav-link-style fs-ms" href="#quick-view" data-bs-toggle="modal">
                                    <i class="fa fa-eye"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="product-card border m-auto pb-0 " v-if="(ProductList==null || ProductList=='') && showEmptyDiv == true">

                    <div class="blog-post border text-danger text-center p-3 bg-dark ">No product(s) available for this category.</div>

                </div>
                <div class="row align-items-center mb-pagination" v-if="showtoalrecords == true">
                    <div class="perPagerecords  col-md-4 p-0">
                        Total Records: {{totalCount}} {{RowsPerPageDropdown}}
                    </div>
                    <div class="col-md-8 text-end">
                        <div class="page_count">
                            <Paginator ref="paginatortempref"
                                       :template=paginatorTemplate
                                       :rows="pageSize"
                                       :totalRecords="totalCount"
                                       :rowsPerPageOptions="pageSizeList"
                                       @page="onPage($event)"
                                       class="p-datatable-footer">
                            </Paginator>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>




    <!--<section class=" bg-grey newlsetter">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-md-4">
                    <div class="newlsetterLogo">
                        <img alt="Site Logo" src="assets/img/logo.png"  />
                        <p>Easy and trusted online shop in US.</p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="newsletter_form">
                        <form>
                            <input type="text" required="" class="form-control rounded-0" placeholder="Enter Email Address">
                            <button type="submit" class="btn btn-dark rounded-0" name="submit" value="Submit">Subscribe</button>
                        </form>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="social">
                        <h3>Follow us on</h3>
                        <a href="#"><i class="fa-brands fa-instagram"></i></a>
                        <a href="#"><i class="fa-brands fa-facebook"></i></a>
                        <a href="#"><i class="fa-brands fa-youtube"></i></a>

                    </div>
                </div>
            </div>
        </div>
    </section>-->

    <Loading v-model:active="isLoading">
    </Loading>



</template>
<script>

    import ECommerce from '@/service/ECommerce.js';
    //import { param } from 'jquery';
    //import VueSlider from 'vue-slider-component'
    //import 'vue-slider-component/theme/default.css'
    import Dropdown from 'primevue/dropdown';
    export default {
        name: 'Products',
        components: {
            Dropdown
        },
        updated() {
            window.scrollTo(0, 0);
        },
        data() {
            let paginatorTemplate = this.$filters.PaginatorTemplate(0, 10);
            var min = 0, max = 20, minVal, maxVal
            return {
                isLoading: false,
                IsFeateured: false,
                ProductCatgoryList: null,
                isMarketPlace: true,
                ProductList: null,
                categoryId: '',
                ProductListData: '',
                fileData: null,
                pageSize: 20,
                pageIndex: 0,
                sortBy: "Images",
                OrderBy: "desc",
                selectedview: null,
                GrideSelect1: 'current_view grid-view',
                ProductListss: null,
                productshort: null,
                searchTxt: '',
                listFilter: '00Test',
                CustomerLoginUserId: "00Test",
                GrideSelect: 'grid-view',
                CurrentCartId: "00Test",
                ProductcategoryId: null,
                companyid: "00Test",
                marketplace: true,
                isfeatured: true,
                featuredproductdetails: [],
                DropdoenDataSortBy:
                    [{ Text: "Sort by Product Name (Asc)", Value: "ProductName" },
                    { Text: "Sort by Product Name (Desc)", Value: "ProductName" },
                    { Text: "Sort by Price (Low to High)", Value: "Price" },
                    { Text: "Sort by Price (High to Low)", Value: "Price" },
                    { Text: "Sort by Latest", Value: "Latest" },
                    { Text: "Sort by Oldest", Value: "Oldest" }],
                value: [min, max],
                minVal, maxVal,
                totalCount: 0,
                pageSizeList: [20, 40, 80],
                pageNumber: 0,
                paginatorTemplate,
                SelectcategoryName: '',
                showEmptyDiv: false,
                showtoalrecords: false,
                CntCategoryName: ''
                //ChooseCategory:'',
            }
        },
        created() {
            debugger;
            if (this.$route.params.Id != null && this.$route.params.Id != undefined) {
                this.ProductcategoryId = this.$route.params.Id;
            }

            this.GetProductCatgoryLists();
            if (this.$route.params.searchProduct != null && this.$route.params.searchProduct != undefined) {
                let routeSearch = (this.$route.params.searchProduct).split('SEARCH-');
                this.searchTxt = routeSearch[1] == undefined ? routeSearch[0] : routeSearch[1];
                this.search();
            }
            else {
                this.productcategoryid(this.ProductcategoryId, 0, "");
            }
            /*   this.GetProductLists();*/
        },
        mounted() {
            this.getfeatureddetails();
        },
        computed: {
            GetCurrentProductId() {
                return this.$route.params.Id;
            }
        },
        watch: {
            GetCurrentProductId() {
                this.productcategoryid(this.$route.params.Id, 0, "");
                this.GetProductCatgoryLists();
            }
        },

        methods: {
            GetActiveCategoryCss(catId) {
                return (this.ProductcategoryId == catId) ? 'nav-link collapsed active' : 'nav-link collapsed ';

            },
            search() {
                this.isLoding = true;

                // Trim whitespace from the searchTxt
                const trimmedSearchTxt = this.searchTxt.trim();


                const sanitizedSearchTxt = trimmedSearchTxt.replace(/[!@#$%^&]/g, '');

                // Use the trimmed search text for filtering
                this.listFilter = sanitizedSearchTxt;

                // Provide a default value if the search text is empty after trimming
                if (sanitizedSearchTxt === "") {
                    this.listFilter = '00Test';
                }

                this.productcategoryid(this.ProductcategoryId, 0, "");
            },



            reset() {
                this.isLoding = true;
                this.listFilter = '00Test';
                this.searchTxt = '';
                this.productcategoryid(this.ProductcategoryId, 0, "");
                this.productshort = '',
                    this.sortBy = 'Images';
                this.OrderBy = 'desc',
                    this.isLoding = true;
                setTimeout(() => { this.isLoding = false; }, 1000);
                if (this.$refs.paginatortempref != null && this.$refs.paginatortempref != undefined) {
                    this.$refs.paginatortempref.changePage(0);
                }
            },


            capitalized(categoryName) {
                var capitalizedFirst = categoryName.split(' ');
                var capitalizedCategoryName = [];
                for (var i = 0; i < capitalizedFirst.length; i++) {
                    capitalizedCategoryName.push(capitalizedFirst[i].charAt(0).toUpperCase() + capitalizedFirst[i].slice(1));
                }
                return capitalizedCategoryName.join(' ');
            },
            getValues() {
                this.valueArray = this.$refs.slider.getValue();
                alert(this.valueArray)
            },
            async GetProductCatgoryLists() {
                this.isLoading = true;
                this.isMarketPlace = true;
                this.IsFeateured = false;
                await ECommerce.GetProductCategoryListFront(this.isMarketPlace, this.IsFeateured, this.companyid).then((response) => {
                    
                    if (this.$filters.IsNull(response.data) != null) {
                        this.ProductCatgoryList = response.data;
                        if (this.ProductcategoryId != null) {
                            this.SelectcategoryName = this.ProductCatgoryList.find(x => x.id.toLowerCase() == this.ProductcategoryId).categoryName;
                            this.CntCategoryName = this.SelectcategoryName;
                        }
                        setTimeout(() => { this.isLoading = false; }, 3000);

                    }


                }).catch((error) => {
                    setTimeout(() => { this.isLoading = false; }, 3000);

                })
            },
            async Clickproductcategory(categoryId, pageIndx, cateName) {
                this.isLoading = true;
                debugger;
                this.ProductcategoryId = categoryId;
                $('#categoryCollapseMenu li').each(function () {
                    $(this).find('a').removeClass('text-warning')
                });
                $(this).addClass("deepakJha");
                $('#' + categoryId).closest('a').addClass('text-warning');
                this.pageIndex = pageIndx;
                this.$router.push({ path: `/Products/${categoryId}` });
            },
            async productcategoryid(categoryId, pageIndx, cateName) {
                this.isLoading = true;
                this.ProductcategoryId = categoryId;
                $('#categoryCollapseMenu li').each(function () {
                    $(this).find('a').removeClass('text-warning')
                });
                $(this).addClass("deepakJha");
                $('#' + categoryId).closest('a').addClass('text-warning');
                this.pageIndex = pageIndx;
                await ECommerce.GetProductListData(this.listFilter, this.pageSize, this.pageIndex, this.sortBy, this.OrderBy, this.ProductcategoryId, this.CustomerLoginUserId, this.CurrentCartId, this.isMarketPlace).then((response) => {
                    this.isLoading = true;
                    this.ProductListss = response.data._productModel;
                    this.ProductList = this.ProductListss;
                    this.totalCount = this.ProductList.length;
                    if (this.totalCount != 0) {
                        this.showEmptyDiv = false;
                        this.showtoalrecords = true;
                    }
                    else {
                        this.showEmptyDiv = true;
                        this.showtoalrecords = false;
                    }
                    this.totalCount = response.data.viewbagTotal;
                    this.paginatorTemplate = this.$filters.PaginatorTemplate(this.totalCount, this.pageSize);
                    if (cateName != null && cateName != "") {
                        this.CntCategoryName = cateName;
                    }
                    setTimeout(() => { this.isLoading = false; }, 3000);
                })
            },
            Path(Id, isShip, localDelCharges) {
                this.isLoading = true;
                if (localStorage.getItem('userId') == null || localStorage.getItem('userId') == '') {
                    this.$router.push({ path: `/Login` });
                }
                else {

                    let subscriptionInfo = localStorage.getItem("SubscriptionDetails");
                    var subscriptiondata = JSON.parse(subscriptionInfo);
                    if (subscriptiondata != null) {
                        if (subscriptiondata.subscriptiontype != null || subscriptiondata.subscriptiontype != 'undefined') {
                            this.error("You cannot add more than one product in subscription!");
                            this.isLoading = false;
                            return false;
                        }
                    }
                    if (isShip == false) {
                        localStorage.setItem('IsShip', isShip)
                        localStorage.setItem('SelectedProductId', Id);
                        localStorage.setItem('localDelCharges', localDelCharges);
                    }

                    localStorage.setItem('cartaction', 'cartcalc');
                    localStorage.removeItem('currentProductId');
                    localStorage.setItem('currentProductId', Id);
                    this.$router.push({ path: `/Cart/${Id}` })
                }

            },
            ProductDetailpage(Id) {
                this.$router.push({ path: `/ProductDetail/${Id}` })
            },
            RedirectToHomePage() {
                this.$router.push({ path: `/Home` });
            },
            RedirectToCurrentPage() {
                this.$router.push({ path: `/ProductList` });
                this.productcategoryid(this.ProductcategoryId, 0, "");
            },

            getfeatureddetails() {
                ECommerce.getfeatureddetails(this.marketplace, this.isfeatured, this.companyid).then((response) => {
                    // debugger;
                    this.featuredproductdetails = response.data;
                    console.log('featureddetails', this.featuredproductdetails);
                    //this.isLoading = false;
                })
            },
            GetsortByProduct(productshort) {
                this.isLoading = true;
                if (productshort == "Sort by Product Name (Asc)") {
                    this.sortBy = "ProductName";
                    this.OrderBy = "asc";
                }
                else if (productshort == "Sort by Product Name (Desc)") {
                    this.sortBy = "ProductName";
                    this.OrderBy = "desc";
                }
                else if (productshort == "Sort by Price (Low to High)") {
                    this.sortBy = "Price";
                    this.OrderBy = "asc";
                }
                else if (productshort == "Sort by Price (High to Low)") {
                    this.sortBy = "Price";
                    this.OrderBy = "desc";
                }
                else if (productshort == "Sort by Latest") {
                    this.sortBy = "CreatedOn";
                    this.OrderBy = "asc";
                }
                else if (productshort == "Sort by Oldest") {
                    this.sortBy = "CreatedOn";
                    this.OrderBy = "desc";
                }
                ECommerce.GetProductListData(this.listFilter, this.pageSize, this.pageIndex, this.sortBy, this.OrderBy, this.ProductcategoryId,
                    this.CustomerLoginUserId, this.CurrentCartId, this.isMarketPlace).then((response) => {
                        this.ProductListss = response.data._productModel;
                        this.ProductList = this.ProductListss;
                        setTimeout(() => { this.isLoading = false; }, 500);

                    });
                /* setTimeout(() => { this.isLoading = false; }, 1000);*/
            },
            onPage(event) {
                this.pageSize = event.rows;
                this.pageIndex = (this.searchTxt != '') ? 0 : event.page;
                this.listFilter = (this.searchTxt == '') ? '00Test' : this.searchTxt;
                //this.productcategoryid(this.ProductcategoryId, this.listFilter);
                this.productcategoryid(this.ProductcategoryId, this.pageIndex, "");
            },
            GetSelectedCategoryProductsLists(categoryId) {

                if (this.$refs.paginatortempref != null && this.$refs.paginatortempref != undefined) {
                    this.$refs.paginatortempref.changePage(0);
                }

                //this.paginatorTemplate = this.$filters.PaginatorTemplate.changePage(0);
                this.pageSize = 20;
                this.pageIndex = 0;
                this.ProductcategoryId = categoryId;
                this.productcategoryid(this.ProductcategoryId, 0, "");
            },


        }
    }








</script>

<style scoped>
    .nav-category .nav-item .nav-link.active {
        color: #ffb300;
    }
</style>